<template>
    <div>
        <div style="display: flex;justify-content: space-between;width: 70%">
            <div></div>
            <div>
                <el-button icon="el-icon-refresh-right" type="success" @click="initActiveStats">刷新</el-button>
            </div>
        </div>

        <div class="active-mng-main">
            <el-table
                    :data="activeStats"
                    v-loading="loading"
                    border
                    @selection-change="handleSelectionChange"
                    size="small"
                    stripe
                    style="width: 70%">
                <el-table-column
                        type="selection"
                        align="center"
                        width="50">
                </el-table-column>
                <el-table-column
                        prop="id"
                        label="ID"
                        align="center"
                        width="50">
                </el-table-column>
                <el-table-column
                        prop="desc"
                        label="状态描述"
                        align="center"
                        width="200">
                    <template slot-scope="scope">
                        <el-tag color="#FFFFFF">{{scope.row.desc}}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column
                        align="center"
                        prop="createTime"
                        label="创建时间">
                </el-table-column>
                <el-table-column
                        align="center"
                        prop="updateTime"
                        label="更新时间">
                </el-table-column>

            </el-table>

        </div>

    </div>
</template>

<script>
    export default {
        name: "ActiveMng",
        data() {
            return {
                loading: false,
                activeStats: []
            }
        },
        mounted() {
            this.initActiveStats();
        },
        methods: {
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            initActiveStats() {
                this.loading = true;
                this.getRequest("/dev/basic/activeStats").then(resp => {
                    this.loading = false;
                    if (resp) {
                        this.activeStats = resp.data;
                    }
                })
            }
        }
    }
</script>

<style>
    .active-mng-main {
        margin-top: 10px;
    }
</style>